import {
  SpesimenLabPermintaan,
  SpesimenLabStatus
} from "@/types/spesimen_lab";

const POLA_WAKTU = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/;

function duaDigit(nilai: number): string {
  return ("0" + nilai).slice(-2);
}

export function waktuKeDate(nilai: string | null | undefined): Date | null {
  const cocok = nilai ? POLA_WAKTU.exec(nilai) : null;
  if (!cocok) {
    return null;
  }

  const [y, m, d, jam, menit] = cocok.slice(1).map(Number);

  return new Date(y, m - 1, d, jam, menit);
}

export function dateKeWaktu(nilai: Date | null | undefined): string | null {
  if (!(nilai instanceof Date) || isNaN(nilai.getTime())) {
    return null;
  }

  return (
    `${nilai.getFullYear()}-${duaDigit(nilai.getMonth() + 1)}-` +
    `${duaDigit(nilai.getDate())} ${duaDigit(nilai.getHours())}:` +
    duaDigit(nilai.getMinutes())
  );
}

export function tampilWaktu(nilai: string | null | undefined): string {
  const cocok = nilai ? POLA_WAKTU.exec(nilai) : null;
  if (!cocok) {
    return "-";
  }

  return `${cocok[3]}-${cocok[2]}-${cocok[1]} ${cocok[4]}:${cocok[5]}`;
}

export function labelPermintaan(permintaan: SpesimenLabPermintaan): string {
  const pemeriksaan = permintaan.pemeriksaan.length
    ? permintaan.pemeriksaan.join(", ")
    : "tanpa item pemeriksaan";

  return `${permintaan.order_number} · ${permintaan.tanggal ||
    "-"} · ${pemeriksaan}`;
}

export const WARNA_STATUS_SPESIMEN: Record<SpesimenLabStatus, string> = {
  available: "success",
  unavailable: "grey",
  unsatisfactory: "deep-orange",
  "entered-in-error": "blue-grey"
};
